<template>
  <div class="new-energy-container">
    <!-- 顶部横幅区域 -->
    <div class="hero-banner">
      <div class="banner-content">
        <h1 class="banner-title">{{ bannerData.title || $t('newEnergy.bannerTitle') }}</h1>
        <p class="banner-subtitle">{{ bannerData.subtitle || $t('newEnergy.bannerSubtitle') }}</p>
        <p class="banner-desc">
          {{ bannerData.description || $t('newEnergy.bannerDescription') }}
        </p>
      </div>
      <div class="banner-image">
        <img :src="bannerData.image || require('@/assets/img/sny/sny01.jpg')" alt="新能源整车运输" />
      </div>
    </div>

    <!-- 核心业务范围 -->
    <div class="section-container">
      <div class="section-header">
        <h2 class="section-title">{{ $t('newEnergy.production.coreBusiness.title') }}</h2>
        <p class="section-subtitle">{{ $t('newEnergy.production.coreBusiness.subtitle') }}</p>
        <div class="title-decoration"></div>
      </div>

      <div class="business-cards">
        <div class="business-card" v-for="(business, index) in coreBusiness" :key="index">
          <div class="card-icon" :style="{ backgroundColor: business.color }">
            <i :class="business.icon"></i>
          </div>
          <h3 class="card-title">{{ business.title }}</h3>
          <p class="card-description">{{ business.description }}</p>
          <ul class="feature-list">
            <li v-for="(feature, featureIndex) in business.features" :key="featureIndex">
              <span class="feature-icon">
                <i class="el-icon-check"></i>
              </span>
              {{ feature }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 关键挑战与专业应对 -->
    <div class="section-container challenge-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('newEnergy.production.keyChallenges.title') }}</h2>
        <p class="section-subtitle">{{ $t('newEnergy.production.keyChallenges.subtitle') }}</p>
        <div class="title-decoration"></div>
      </div>

      <div class="challenge-grid">
        <div class="challenge-item" v-for="(challenge, index) in keyChallenges" :key="index">
          <div class="challenge-icon" :style="{ backgroundColor: challenge.color }">
            <i :class="challenge.icon"></i>
          </div>
          <h3 class="challenge-title">{{ challenge.title }}</h3>
          <p class="challenge-desc">{{ challenge.description }}</p>
          <div class="solution-list">
            <div class="solution-item" v-for="(solution, solIndex) in challenge.solutions" :key="solIndex">
              <span class="solution-badge">{{ solIndex + 1 }}</span>
              <span>{{ solution }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 安全与专业保障 -->
    <div class="section-container safety-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('newEnergy.production.safetyGuarantees.title') }}</h2>
        <p class="section-subtitle">{{ $t('newEnergy.production.safetyGuarantees.subtitle') }}</p>
        <div class="title-decoration"></div>
      </div>

      <div class="safety-features">
        <div class="safety-item" v-for="(safety, index) in safetyGuarantees" :key="index">
          <div class="safety-image">
            <img :src="safety.image" :alt="safety.title" />
          </div>
          <div class="safety-content">
            <h3 class="safety-title">{{ safety.title }}</h3>
            <p class="safety-desc">{{ safety.description }}</p>
            <ul class="safety-list">
              <li v-for="(item, itemIndex) in safety.items" :key="itemIndex">
                <i class="el-icon-success"></i>
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 绿色物流实践 -->
    <div class="section-container green-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('newEnergy.production.greenPractices.title') }}</h2>
        <p class="section-subtitle">{{ $t('newEnergy.production.greenPractices.subtitle') }}</p>
        <div class="title-decoration"></div>
      </div>

      <div class="green-practices">
        <div class="practice-item" v-for="(practice, index) in greenPractices" :key="index">
          <div class="practice-icon" :style="{ backgroundColor: practice.color }">
            <i :class="practice.icon"></i>
          </div>
          <h3 class="practice-title">{{ practice.title }}</h3>
          <p class="practice-desc">{{ practice.description }}</p>
        </div>
      </div>
    </div>

    <!-- 典型服务流程 -->
    <div class="section-container process-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('newEnergy.production.serviceProcess.title') }}</h2>
        <p class="section-subtitle">{{ $t('newEnergy.production.serviceProcess.subtitle') }}</p>
        <div class="title-decoration"></div>
      </div>

      <div class="process-timeline">
        <div class="process-step" v-for="(step, index) in serviceProcess" :key="index">
          <div class="step-number">{{ index + 1 }}</div>
          <div class="step-content">
            <h3 class="step-title">{{ step.title }}</h3>
            <p class="step-desc">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import { getNewEnergyProductionData } from '@/api/new-energy'

export default {
  name: 'ProductionBrain',
  components: {
    CallMe,
    MobileCallme
  },
  data() {
    return {
      loading: false,
      // 核心业务范围
      coreBusiness: [],
      // 关键挑战与专业应对
      keyChallenges: [],
      // 安全与专业保障
      safetyGuarantees: [],
      // 绿色物流实践
      greenPractices: [],
      // 典型服务流程
      serviceProcess: [],
      // 横幅数据
      bannerData: {
        title: '',
        subtitle: '',
        description: '',
        image: ''
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.loading = true
        console.log('开始加载新能源数据...')
        const response = await getNewEnergyProductionData()
        console.log('API响应:', response)
        
        // 检查响应结构
        if (response && response.data) {
          // 如果响应有code字段，说明是标准API响应格式
          if (response.data.code === 200 && response.data.data) {
            const data = response.data.data
            console.log('解析后的数据:', data)
            this.coreBusiness = data.coreBusiness || []
            this.keyChallenges = data.keyChallenges || []
            this.safetyGuarantees = data.safetyGuarantees || []
            this.greenPractices = data.greenPractices || []
            this.serviceProcess = data.serviceProcess || []
            this.bannerData = data.banner || {}
          } else if (response.data.coreBusiness) {
            // 如果响应直接包含数据字段，说明是直接的数据结构
            const data = response.data
            console.log('解析后的数据(直接结构):', data)
            this.coreBusiness = data.coreBusiness || []
            this.keyChallenges = data.keyChallenges || []
            this.safetyGuarantees = data.safetyGuarantees || []
            this.greenPractices = data.greenPractices || []
            this.serviceProcess = data.serviceProcess || []
            this.bannerData = data.banner || {}
          } else {
            console.warn('API返回数据格式不正确:', response)
            this.setDefaultData()
          }
          
          console.log('数据设置完成:', {
            coreBusiness: this.coreBusiness,
            keyChallenges: this.keyChallenges,
            safetyGuarantees: this.safetyGuarantees,
            greenPractices: this.greenPractices,
            serviceProcess: this.serviceProcess,
            bannerData: this.bannerData
          })
        } else {
          console.warn('API返回数据为空:', response)
          this.setDefaultData()
        }
      } catch (error) {
        console.error('加载新能源数据失败:', error)
        // 如果API调用失败，使用默认数据
        this.setDefaultData()
      } finally {
        this.loading = false
      }
    },
    setDefaultData() {
      // 设置默认数据，确保页面正常显示
      this.coreBusiness = [
        {
          title: '全链路运输模式',
          description: '灵活采用滚装船运输、集装箱化运输及铁海联运等多式联运方案',
          icon: 'el-icon-ship',
          color: '#4CAF50',
          features: [
            '滚装船运输方案',
            '特种框架平板箱装载',
            '开顶箱装载车辆',
            '铁海联运无缝衔接'
          ]
        },
        {
          title: '端到端物流服务',
          description: '一站式服务涵盖出口报关、订舱配载、港口操作等全流程',
          icon: 'el-icon-document',
          color: '#2196F3',
          features: [
            '出口报关服务',
            '订舱配载管理',
            '港口操作协调',
            '目的港清关配送'
          ]
        },
        {
          title: '专业化车辆处理与仓储',
          description: '提供针对高价值车辆的专业储存和装卸服务',
          icon: 'el-icon-office-building',
          color: '#FF9800',
          features: [
            '专业绑扎固定',
            '车辆PDI检测',
            '短期仓储服务',
            '高价值车辆保护'
          ]
        }
      ]

      this.keyChallenges = [
        {
          title: '锂电池运输安全',
          description: '电动汽车搭载的锂离子电池属于9类危险品，存在热失控引发火灾风险',
          icon: 'el-icon-warning',
          color: '#F44336',
          solutions: [
            '专业包装方案',
            '温度监控系统',
            '绑扎固定技术',
            '应急预案制定'
          ]
        },
        {
          title: '法规与合规性',
          description: '确保运输满足国际海事组织及相关国家地区关于锂电池运输的法规',
          icon: 'el-icon-document-checked',
          color: '#9C27B0',
          solutions: [
            'IMO法规遵循',
            '中国船级社指南',
            '针对性规范执行',
            '合规文件管理'
          ]
        },
        {
          title: '供应链韧性及成本优化',
          description: '面对全球运力紧张及航线多变情况，保障供应链稳定并控制成本',
          icon: 'el-icon-trend-charts',
          color: '#607D8B',
          solutions: [
            '多元运输方案',
            '铁海联运优化',
            '路由优化设计',
            '成本控制策略'
          ]
        }
      ]

      this.safetyGuarantees = [
        {
          title: '技术装备与工艺保障',
          description: '使用专业设备和技术确保运输安全',
          image: require('@/assets/img/sny/sny02.jpg'),
          items: [
            '专用框架平板箱、开顶箱等特种箱型',
            '专业绑扎加固材料和技术',
            '技术图表进行精准装载方案设计',
            '先进设备保障运输安全'
          ]
        },
        {
          title: '合规与标准操作流程',
          description: '遵循特定规范执行标准化流程',
          image: require('@/assets/img/sny/sny03.jpg'),
          items: [
            '遵循中国船级社《新能源汽车滚装运输安全技术指南》',
            '标准化装船、绑扎、固定流程',
            '全程监控流程执行',
            '定期安全审计检查'
          ]
        },
        {
          title: '专业团队与全程可视化管理',
          description: '经验丰富的团队配合先进管理系统',
          image: require('@/assets/img/sny/sny04.jpg'),
          items: [
            '经验丰富的项目物流团队',
            'WMS、TMS管理系统应用',
            '控制塔实时跟踪管理',
            '全程物流可视化管理'
          ]
        }
      ]

      this.greenPractices = [
        {
          title: '环保船型应用',
          description: '采用液化天然气（LNG）双燃料动力汽车运输船等环保船型',
          icon: 'el-icon-ship',
          color: '#4CAF50'
        },
        {
          title: '运输路径优化',
          description: '通过优化运输路径、采用铁海联运等混合模式降低碳足迹',
          icon: 'el-icon-map-location',
          color: '#2196F3'
        },
        {
          title: '岸电使用',
          description: '船舶靠港使用岸电等方式，减少碳排放',
          icon: 'el-icon-lightning',
          color: '#FF9800'
        }
      ]

      this.serviceProcess = [
        {
          title: '需求对接与方案设计',
          description: '明确运输要求，定制涵盖运输方式、路由、包装加固及清关的个性化物流方案'
        },
        {
          title: '订舱与空箱调配',
          description: '根据方案，向船公司申请滚装船舱位或特种集装箱'
        },
        {
          title: '起运地操作',
          description: '安排拖车、装货、内陆运输、报关等事宜'
        },
        {
          title: '港口操作及装船',
          description: '进行车辆验收、文件核对、绑扎加固并装船'
        },
        {
          title: '国际干线运输及在途监控',
          description: '船舶航行，并提供全程物流状态跟踪'
        },
        {
          title: '目的港操作及末端配送',
          description: '完成目的港清关，并根据需要安排末端运输至指定经销商或仓库'
        }
      ]

      this.bannerData = {
        title: '新能源整车运输',
        subtitle: '安全、高效、合规的全球物流解决方案',
        description: '为汽车制造商提供专业的新能源整车全球运输服务，涵盖全链路运输模式、端到端物流服务及专业化车辆处理',
        image: require('@/assets/img/sny/sny01.jpg')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.new-energy-container {
  width: 100%;
  padding-top: 0;
}

// 顶部横幅区域
.hero-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 10%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  min-height: 500px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 40px 5%;
    text-align: center;
  }

  .banner-content {
    flex: 1;
    max-width: 50%;

    @media (max-width: 768px) {
      max-width: 100%;
      margin-bottom: 30px;
    }

    .banner-title {
      font-size: 3.5rem;
      font-weight: 700;
      margin-bottom: 20px;
      line-height: 1.2;

      @media (max-width: 768px) {
        font-size: 2.5rem;
      }
    }

    .banner-subtitle {
      font-size: 1.5rem;
      margin-bottom: 15px;
      opacity: 0.9;

      @media (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    .banner-desc {
      font-size: 1.1rem;
      line-height: 1.6;
      opacity: 0.8;
      max-width: 500px;

      @media (max-width: 768px) {
        font-size: 1rem;
      }
    }
  }

  .banner-image {
    flex: 1;
    max-width: 45%;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);

    @media (max-width: 768px) {
      max-width: 100%;
    }

    img {
      width: 100%;
      height: 300px;
      object-fit: cover;
      border-radius: 20px;
    }
  }
}

// 通用区域样式
.section-container {
  padding: 100px 10%;

  @media (max-width: 768px) {
    padding: 60px 5%;
  }

  &.challenge-section {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  }

  &.safety-section {
    background: white;
  }

  &.green-section {
    background: linear-gradient(135deg, #e8f5e8 0%, #f0f8f0 100%);
  }

  &.process-section {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  }
}

// 区域头部样式
.section-header {
  text-align: center;
  margin-bottom: 80px;

  .section-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 16px;
    position: relative;
    letter-spacing: -0.8px;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  .section-subtitle {
    font-size: 1.2rem;
    color: #64748b;
    margin-bottom: 30px;
    font-weight: 400;
    line-height: 1.6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    letter-spacing: -0.2px;
  }

  .title-decoration {
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%);
    margin: 0 auto;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  }
}

// 业务卡片样式
.business-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

.business-card {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.06);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 1px solid #f1f5f9;
  text-align: center;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  }

  .card-icon {
    width: 80px;
    height: 80px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 25px;
    color: white;
    font-size: 2rem;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
  }

  .card-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 15px;
  }

  .card-description {
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 20px;
    font-size: 1rem;
  }

  .feature-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      color: #475569;
      font-size: 0.95rem;
      
      .feature-icon {
        color: #3b82f6;
        margin-right: 10px;
        font-size: 1rem;
      }
    }
  }
}

// 挑战网格样式
.challenge-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

.challenge-item {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.06);
  transition: all 0.4s ease;
  border: 1px solid #f1f5f9;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  }

  .challenge-icon {
    width: 70px;
    height: 70px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    color: white;
    font-size: 1.8rem;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  }

  .challenge-title {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 15px;
  }

  .challenge-desc {
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 25px;
    font-size: 1rem;
  }

  .solution-list {
    .solution-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      padding: 8px 0;
      
      .solution-badge {
        background: #3b82f6;
        color: white;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.8rem;
        font-weight: 600;
        margin-right: 12px;
        flex-shrink: 0;
      }
    }
  }
}

// 安全特性样式
.safety-features {
  max-width: 1200px;
  margin: 0 auto;
}

.safety-item {
  display: flex;
  align-items: center;
  margin-bottom: 60px;
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.06);
  border: 1px solid #f1f5f9;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 30px 20px;
  }

  &:nth-child(even) {
    flex-direction: row-reverse;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .safety-image {
    flex: 1;
    max-width: 40%;
    border-radius: 15px;
    overflow: hidden;

    @media (max-width: 768px) {
      max-width: 100%;
      margin-bottom: 20px;
    }

    img {
      width: 100%;
      height: 250px;
      object-fit: cover;
      border-radius: 15px;
    }
  }

  .safety-content {
    flex: 1;
    padding: 0 40px;

    @media (max-width: 768px) {
      padding: 0;
    }

    .safety-title {
      font-size: 1.6rem;
      font-weight: 700;
      color: #1e293b;
      margin-bottom: 15px;
    }

    .safety-desc {
      color: #64748b;
      line-height: 1.6;
      margin-bottom: 20px;
      font-size: 1rem;
    }

    .safety-list {
      list-style: none;
      padding: 0;
      margin: 0;
      
      li {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        color: #475569;
        font-size: 0.95rem;
        
        i {
          color: #4CAF50;
          margin-right: 10px;
          font-size: 1rem;
        }
      }
    }
  }
}

// 绿色实践样式
.green-practices {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 32px;
  max-width: 1000px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

.practice-item {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.06);
  transition: all 0.4s ease;
  border: 1px solid #f1f5f9;
  text-align: center;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  }

  .practice-icon {
    width: 70px;
    height: 70px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 25px;
    color: white;
    font-size: 1.8rem;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  }

  .practice-title {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 15px;
  }

  .practice-desc {
    color: #64748b;
    line-height: 1.6;
    font-size: 1rem;
  }
}

// 服务流程时间线样式
.process-timeline {
  max-width: 1000px;
  margin: 0 auto;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(to bottom, #3b82f6, #1d4ed8);
    transform: translateX(-50%);

    @media (max-width: 768px) {
      left: 30px;
    }
  }
}

.process-step {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  position: relative;

  &:nth-child(odd) {
    flex-direction: row;

    @media (max-width: 768px) {
      flex-direction: row;
    }

    .step-content {
      margin-left: 40px;

      @media (max-width: 768px) {
        margin-left: 40px;
      }
    }
  }

  &:nth-child(even) {
    flex-direction: row-reverse;

    @media (max-width: 768px) {
      flex-direction: row;
    }

    .step-content {
      margin-right: 40px;
      text-align: right;

      @media (max-width: 768px) {
        margin-right: 0;
        margin-left: 40px;
        text-align: left;
      }
    }
  }

  .step-number {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: 700;
    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.3);
    flex-shrink: 0;
    z-index: 2;
  }

  .step-content {
    flex: 1;
    background: white;
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #f1f5f9;

    .step-title {
      font-size: 1.3rem;
      font-weight: 700;
      color: #1e293b;
      margin-bottom: 10px;
    }

    .step-desc {
      color: #64748b;
      line-height: 1.6;
      font-size: 1rem;
    }
  }
}
</style>
